"use strict";

jQuery(($) => {
	// Put pure JS here!
});